var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BFormTextarea',_vm._g(_vm._b({attrs:{"state":_vm.input_state,"value":_vm.value}},'BFormTextarea',_vm.$attrs,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }